function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M33.733 31.608l1.31 1.31a1.5 1.5 0 0 1-2.12 2.122L31.61 33.73l-1.31 1.311a1.5 1.5 0 0 1-2.122-2.121l1.311-1.311-1.31-1.311a1.5 1.5 0 0 1 2.12-2.122l1.311 1.311 1.312-1.31a1.5 1.5 0 1 1 2.12 2.12l-1.31 1.312zm-2.243 7.378a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3c-5.8 0-10.5-4.701-10.5-10.5s4.7-10.5 10.5-10.5c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5zm-6-30v-4.5h3v7a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-7h3v4.5h6zm-12 15a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm25.475-2.953h-3V10.5a1.5 1.5 0 0 0-1.5-1.5H10.5A1.5 1.5 0 0 0 9 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h11.99v3H10.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 10.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533z"
});

var SvgDeliveryFailed = function SvgDeliveryFailed(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryFailed;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-failed.svg
// module id = 176
// module chunks = 0 1